import { map } from 'lodash'
const prepareSave = covenant => {
  covenant.plans = map(covenant.plans, plan => {
    return {
      covenant_plan_id: plan.id
    }
  })
  if (covenant.plans.lenght === 0) {
    delete covenant.plans
  }

  return covenant
}

export default {
  prepareSave,
  setPlansFromCovenant (covenant) {
    this.plans = covenant.active_plans
  },
  afterUpdated () {
    this.beenUpdated = true
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/edit/resources/methods.js